import { Label } from 'labels';
import { parseISO } from 'date-fns';
import { Message, Scalars, Unlock_Request_Type_Enum } from 'generated/graphql';
import { getDateTxt } from 'home/useSubBoxStatuses';
import { ColumnWithStrictAccessor } from 'react-table';

const Value = (value: Scalars['jsonb'] | null | undefined) => {
  if (value) {
    if ('is_unlocked' in value && 'is_open' in value) {
      const battery = value.is_backup_battery
        ? Label.BackupBattery
        : Label.NormalBattery;
      const door = value.is_open ? Label.DoorOpen : Label.DoorClose;
      const key = value.is_unlocked ? Label.KeyOpen : Label.KeyClose;

      return `${door} | ${key} | ${battery}`;
    }
    if ('type' in value) {
      switch (value.type) {
        case Unlock_Request_Type_Enum.Success:
          return '受信確認';
        case Unlock_Request_Type_Enum.UnlockError:
          return '制御エラー';
        case Unlock_Request_Type_Enum.ReceiveError:
          return '受信データエラー';
        case Unlock_Request_Type_Enum.Request:
          return '送信';
        case Unlock_Request_Type_Enum.Timeout:
          return 'タイムアウト';
      }
    }
    if ('is_unlocked' in value) return value.is_unlocked ? 'OPEN' : 'CLOSE';
    if ('is_open' in value) return value.is_open ? 'OPEN' : 'CLOSE';
    if ('is_backup_battery' in value)
      return value.is_backup_battery
        ? Label.BackupBattery
        : Label.NormalBattery;
  }
  return JSON.stringify(value);
};

const Type = (value: string | null | undefined) => {
  switch (value) {
    case 'BOX':
      return '扉';

    case 'BATTERY':
      return '電池';

    case 'KEY':
      return '鍵';

    case 'BOOT_REGULAR':
      return '起動・定時';

    case 'UNLOCK_REQUEST':
      return '鍵操作';
  }
  return value;
};

export const columns: ColumnWithStrictAccessor<Message>[] = [
  {
    Header: '時間',
    accessor: 'created_at',
    Cell: ({ value }) => getDateTxt(parseISO(value ?? '')),
  },
  {
    Header: '種別',
    accessor: 'type',
    Cell: ({ value }) => Type(value),
  },
  {
    Header: '状態',
    accessor: 'value',
    Cell: ({ value }) => Value(value),
  },
];
